import React, { useState, useEffect } from "react";
import styled from "styled-components";
import BreadCrums from "../components/BreadCrums";
import config from "../config/app.json";
import useCheckIsMobile from "../hooks/useCheckIsMobile";

const HeroSectionWrapper = styled.section`
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  display: flex;
  align-items: flex-end;
  padding: 0px 50px;
  box-sizing: border-box;
  @media (max-width: 425px) {
    padding: 0px;
  }
  ${(props) =>
    props.url
      ? `background-image: url(${props.url})`
      : `background-image: linear-gradient(45deg, #fc5296, #f67062)`}
`;

const HeroSectionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  margin: 0 auto;
  width: 100%;
  @media (max-width: 425px) {
    padding: 10px 15px;
  }
`;

const HeroTitle = styled.h1`
  font-family: "DM Serif Display Regular", serif;
  font-size: 34px;
  color: #ffffff;
  margin: 16px 0px;
  line-height: normal;
  text-transform: capitalize;
  @media (max-width: 425px) {
    text-align: center;
    line-height: 1.5;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 18px;
  font-family: "Lato";
  color: #ffffff;
  margin: 0px;
  line-height: 1.5;
  @media (max-width: 425px) {
    text-align: center;
    line-height: 1.5;
  }
`;

const HeroTitleContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

const HeroHeadContainer = styled.div`
  padding: 80px 0px;
  max-width: 50%;
  @media (max-width: 767px) {
    max-width: 100%;
    padding: 80px 40px;
  }
  @media (max-width: 425px) {
    padding: 20px 0px;
  }
`;

const BreadCrumsContainer = styled.div`
  background-color: #fff;
  padding: 20px 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const HeroImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: flex-end;
  min-width: 300px;
  img {
    max-height: 250px;
  }
  @media (max-width: 767px) {
    display: none;
  }
`;

const appUrl = config["APPURLS"][config["APPURLS"]["current"]];
const BASE_PATH = process.env.BASE_PATH;
export default function HeroSection({
  title,
  byline,
  banner_img,
  toShowMessage,
}) {
  const name = title || "";
  const { isMobileWidth } = useCheckIsMobile();

  return (
    <React.Fragment>
      {isMobileWidth && (
        <BreadCrumsContainer>
          <BreadCrums isMobile={isMobileWidth} />
        </BreadCrumsContainer>
      )}
      <HeroSectionWrapper>
        <HeroSectionContainer>
          <HeroHeadContainer>
            {!isMobileWidth && <BreadCrums />}
            {title && (
              <HeroTitleContainer>
                <HeroTitle>{name}</HeroTitle>
                {!toShowMessage && <HeroSubtitle>{byline}</HeroSubtitle>}
              </HeroTitleContainer>
            )}
          </HeroHeadContainer>
          <HeroImageContainer>
            <img
              src={`${appUrl}landing/banner/${banner_img}`}
              alt="template-image"
              title="template-image"
              width="100%"
              height="100%"
              rel="preload"
            />
          </HeroImageContainer>
        </HeroSectionContainer>
      </HeroSectionWrapper>
    </React.Fragment>
  );
}
